/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface Unit {
  id: number
  property_id: number
  property_name?: string
  name: string
  type: string
  rent_amount: number
  deposit_amount?: number
  status: 'occupied' | 'vacant'
  tenant_name?: string
}

export interface UnitsState {
  list: Unit[]
  loading: boolean
}

const units: Module<UnitsState, RootState> = {
  namespaced: true,

  state: (): UnitsState => ({
    list: [],
    loading: false
  }),

  getters: {
    all: (state) => state.list,
    vacant: (state) => state.list.filter(u => u.status === 'vacant'),
    loading: (state) => state.loading
  },

  mutations: {
    SET_LIST (state, list: Unit[]) { state.list = list },
    SET_LOADING (state, val: boolean) { state.loading = val },
    ADD (state, unit: Unit) { state.list.unshift(unit) },
    UPDATE (state, updated: Unit) {
      const i = state.list.findIndex(u => u.id === updated.id)
      if (i !== -1) state.list.splice(i, 1, updated)
    },
    REMOVE (state, id: number) {
      state.list = state.list.filter(u => u.id !== id)
    }
  },

  actions: {
    async fetchAll ({ commit }, propertyId?: number) {
      commit('SET_LOADING', true)
      try {
        const params = propertyId ? { property_id: propertyId } : {}
        const { data } = await api.get('/units', { params })
        commit('SET_LIST', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async create ({ commit }, payload: Partial<Unit>) {
      const { data } = await api.post('/units', payload)
      commit('ADD', data.data ?? data)
      return data
    },

    async update ({ commit }, { id, ...payload }: Partial<Unit> & { id: number }) {
      const { data } = await api.put(`/units/${id}`, payload)
      commit('UPDATE', data.data ?? data)
      return data
    },

    async remove ({ commit }, id: number) {
      await api.delete(`/units/${id}`)
      commit('REMOVE', id)
    }
  }
}

export default units
